import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * /v2/auth password flows (PD-1512). Stateless one-shots: no cookies, no challenge.
 * reset-password keeps recaptcha (parity with today — the only gateway endpoint that
 * does); set-password completes the emailed link and clears any login lockout.
 */

export const authResetPassword = oc
  .route({ method: 'POST', path: '/v2/auth/reset-password' })
  .input(
    z.object({
      email: z.string().min(3).max(72),
      recaptchaToken: z.string().optional(),
    }),
  )
  // Always ok — whether the account exists is never revealed (OWASP account enumeration).
  .output(z.object({ ok: z.literal(true) }))

export const authSetPassword = oc
  .route({ method: 'POST', path: '/v2/auth/set-password' })
  .input(
    z.object({
      id: z.string().uuid(),
      secret: z.string().min(1),
      password: z.string().min(8),
    }),
  )
  .output(z.object({ ok: z.literal(true) }))
